import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const instrumentationKey = process.env.VUE_APP_APP_INSIGHTS_INSTRUMENTATION_KEY

let appInsights = null

if (instrumentationKey) {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey
    }
  })

  appInsights.loadAppInsights()
  appInsights.trackPageView()
}

export default appInsights
